import React from 'react';

const MegaphoneIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Megaphone body */}
    <path
      d="M13.5 3.5V12.5C13.5 12.5 10.5 11 8 11H5C4.2 11 3.5 10.3 3.5 9.5V6.5C3.5 5.7 4.2 5 5 5H8C10.5 5 13.5 3.5 13.5 3.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Handle/stand */}
    <path
      d="M5.5 11V14C5.5 14.6 5.9 15 6.5 15H7.5C8.1 15 8.5 14.6 8.5 14V11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Sound waves */}
    <path
      d="M15.5 6.5C16.1 7.1 16.5 7.8 16.5 8C16.5 8.2 16.1 8.9 15.5 9.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MegaphoneIcon;
